import { useMemo } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellGitTag from "ds/components/Table/Row/CellGitTag";
import { StackSuggestions } from "constants/stack";

import useStackListAnalytics from "../../useStackListAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const StacksTableGitTagCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const trackAnalytics = useStackListAnalytics();

  const { trackedCommit } = stack;

  const isEmpty = !trackedCommit?.tag;

  const gitTagFilterAction = useCellFilterAction({
    filterName: StackSuggestions.GitTag,
    filterValue: trackedCommit?.tag || "",
  });

  const actions = useMemo(
    () => (isEmpty ? undefined : [gitTagFilterAction]),
    [isEmpty, gitTagFilterAction]
  );

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}

      {!isEmpty && (
        <TableCellGitTag
          href={trackedCommit.url}
          onPress={() => trackAnalytics("Tag link clicked")}
          tooltip="Tracked git commit tag"
        >
          {trackedCommit.tag}
        </TableCellGitTag>
      )}
    </TableSimpleCell>
  );
};

export default StacksTableGitTagCell;
